import React from "react";

export default function ImageButton ({
  imgSrc,
  text,
  onClick,
  selected,
  children,
}: {
  imgSrc?: string,
  text?: string,
  onClick?: ()=>void,
  selected?: boolean,
  children?: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center bg-black
        ${selected ? "bg-opacity-10" : "bg-opacity-0"} p-2 rounded`}
    >
      <div className="relative h-10 w-10 rounded">
        {children}
        {imgSrc && <img className="h-full w-full" src={imgSrc} />}
      </div>
      <label>{text}</label>
    </button>
  )
}
